var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('div',{staticClass:"title"},[_vm._v("Support")]),_c('div',[_vm._v("\n    For help, please contact us at support@omentum.freshdesk.com.\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }